import { TextField } from '@mui/material';
import React from 'react';
import { loginPageStyles } from '../../../../styles';
import PropTypes from 'prop-types';

const ALPHABET_REGEX = /^[a-zA-Z ]*$/;
function InputForSignatureIndication(props) {
  const classes = loginPageStyles();
  const handleChange = (e) => {
    if (ALPHABET_REGEX.test(e.target.value)) {
      props.setSignatureIndication(e.target.value);
    }
  };
  return (
    <TextField
      size="small"
      fullWidth
      placeholder="Name"
      className={classes.textField}
      value={props.value}
      onChange={handleChange}
    />
  );
}
InputForSignatureIndication.propTypes = {
  setSignatureIndication: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};
export default InputForSignatureIndication;
